import { useState } from "react";

const ProgressiveImg: React.FC<any> = (props) => {
    const [imgUrl,setImgUrl] = useState(props.src)
    return <img {...props} loading='lazy' src={imgUrl} onError={()=>{
        setImgUrl(props.defaultUrl)
    }}/>
};

export default ProgressiveImg;
